import { FACET_COMPONENT_MAP } from '@/components/c-filter.vue';
import { Facet } from '@/types/facet';

const isValidCheckboxFacet = (facet: Facet): boolean => facet.values.some(value => value.code === 'true');

export default function filterValidFacets(facets: Facet[]): Facet[] {
  return facets.filter(facet => Object.keys(FACET_COMPONENT_MAP).includes(facet.displayType)
    && (facet.displayType !== 'CHECKBOX_BOOLEAN' || isValidCheckboxFacet(facet)));
}
